/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SearchInteractionAction = {
    Impression: 'impression',
    Click: 'click',
    DetailView: 'detail_view',
    Bookmark: 'bookmark',
    Book: 'book'
} as const;
export type SearchInteractionAction = typeof SearchInteractionAction[keyof typeof SearchInteractionAction];


export function instanceOfSearchInteractionAction(value: any): boolean {
    for (const key in SearchInteractionAction) {
        if (Object.prototype.hasOwnProperty.call(SearchInteractionAction, key)) {
            if (SearchInteractionAction[key as keyof typeof SearchInteractionAction] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SearchInteractionActionFromJSON(json: any): SearchInteractionAction {
    return SearchInteractionActionFromJSONTyped(json, false);
}

export function SearchInteractionActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchInteractionAction {
    return json as SearchInteractionAction;
}

export function SearchInteractionActionToJSON(value?: SearchInteractionAction | null): any {
    return value as any;
}

export function SearchInteractionActionToJSONTyped(value: any, ignoreDiscriminator: boolean): SearchInteractionAction {
    return value as SearchInteractionAction;
}

